import { GEOLOCATION_TIMEOUT } from './constants'

export function getLocation(cb, err = () => {}, opts = {
  timeout: GEOLOCATION_TIMEOUT
}) {
  const innerErr = (errObj) => {
    switch(errObj.code) {
      case 1: //PERMISSION_DENIED PositionError.code
        return err("Geolocation not allowed")
      case 2: //POSITION_UNAVAILABLE PositionError.code
        return err("Geolocation unavailable")
      case 3: //TIMEOUT PositionError.code
        return err("Geolocation timeout")
      default:
        return err(errObj.message)
    }
  }

  if(navigator.geolocation) {
    return navigator.geolocation.getCurrentPosition(cb, innerErr, opts)
  } else {
    return err("Geolocation not supported")
  }
}

export function getLatLongFromText(text) {
  var result = {
    lat: undefined,
    long: undefined,
    text
  }

  const latLongRegex = /^(?:lat\D*?)?(-?[\d]+\.?[\d]*)\D+?(?:long\D*?)?(-?[\d]+\.?[\d]*)$/
  if(text) {
    var matches = text.match(latLongRegex)
    if(matches) {
      result.lat = Number.parseFloat(matches[1])
      result.long = Number.parseFloat(matches[2])
    }
  }
  return result
}



// WEBPACK FOOTER //
// ./src/util/location.js